import React, { Component } from "react";
import NavMenu from "../../navmenu/NavMenu";
import ProjectHeader from "./ProjectHeader";
import ProjectImage from "./ProjectImage";
import bigImage from "../../../assets/images/product-manufacturing-desktop-header.jpg";
import "../../../styles/pages/projects/Project.css";
import mobile1 from "../../../assets/images/product-manufacturing-mobile-1.png";
import mobile2 from "../../../assets/images/product-manufacturing-mobile-2.png";
import gif from "../../../assets/images/product-manufacturing-gif.gif";
import ProjectConclusion from "./ProjectConclusion";
import Footer from "../../footer/Footer";
import onScrollHandler from "../../../utilities/onScrollHandler";
import NextPrompt from "../../nextprompt/NextPrompt";

export default class ProductManufacturing extends Component {
  componentDidMount() {
    this.onScrollHandler = new onScrollHandler();
  }
  render() {
    return (
      <div className="ProductManufacturing page-wrapper">
        <NavMenu />
        <ProjectHeader
          title="PRODUCT MANU- FACTURING"
          year="2019"
          contributions={["Web Design", "Website Development", "Copywriting"]}
          projectLink={"#"}
          description={
            <div>
              Product Manufacturing is a precision metal machine shop located in
              Canby, Oregon. In May, 2019, they decided it was time for an
              update and tasked us with creating their brand new site.
              <br />
              <br />
              They needed a fresh looking, fully responsive, and well designed
              website.
            </div>
          }
        />
        <ProjectImage
          projectName={"Product Manufacturing"}
          layout={"big-image"}
          image={bigImage}
          backgroundColor={"#CEFFE7"}
        />
        <div className="gutters">
          <div className="project-text g-sub-text on-scroll-anim">
            Our initial thoughts going into this project were that Product
            Manufacturing’s clients don’t have to be sold, they have to be
            informed. They work with many different machines and materials, and
            it's necessary for potential clients to make sure Product
            Manufacturing can produce what they need.
            <br />
            <br />
            Their old site was difficult to understand: There was a lot of
            unnecessary, filler information, keyword jamming, and the design was
            just plain outdated.
            <br />
            <br />
            We spent a lot of time early in the project figuring out the best
            ways to consolidate and simplify all of the information from the old
            site. The page structure had to be completely re-thought, and the
            design needed to allow users to easily find and read the information
            they were looking for.
          </div>
        </div>
        <ProjectImage
          projectName={"Product Manufacturing"}
          layout={"gif-showcase"}
          mobileImages={[mobile1, mobile2]}
          gif={gif}
          backgroundColor={"#CEFFE7"}
        />
        <ProjectConclusion
          text={
            <div>
              This project presented many new obstacles specific to this
              industry that we hadn’t faced before. In the end, it was a great
              learning experience, and we’re very happy with how the site turned
              out.
            </div>
          }
        />

        <NextPrompt />
        <Footer page={"product"} />
      </div>
    );
  }
}
